<div class="wrapper">
  <ng-template #contentContainer></ng-template>
  <button *ngIf="data.showClose" class="close-button" (click)="closeClicked()">Schließen</button>
</div>
